import React from 'react'

const SideBar = () => {
    return (
        <section>
            <link href="https://fonts.googleapis.com/css?family=Montserrat|Open+Sans&display=swap" rel="stylesheet"></link>
            <div class = 'container'>
                <div class = 'row'>
                    <div class = 'col-12 col-md-12'>
                    <h2 class = 'pt-5 text-center DesingCat'>Categorias</h2>
                        <ul class = 'list-unstyled text-white font-weight-bold'>

                            <div class = 'side-bar mt-2 pt-4 imagem-dicas'>
                                <li>
                                    <a class = 'text-white imagem-dicas' 
                                        href = '/blog'
                                        >DICAS
                                    </a>
                                </li>
                             </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/tecnologia'
                                        >TECNOLOGIA
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar mt-2 pt-4 imagem-videos'>
                                <li>
                                    <a class = 'text-white'
                                        href = '/videos/'
                                        >VIDEOS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar mt-2 pt-4 imagem-videosTuto'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/video-tutorial'
                                        >VIDEO-TUTORIAL
                                    </a>
                                </li>
                            </div>
                        </ul>

                        <h2 class = 'pt-4 text-center DesingTemas'>Temas</h2>
                        <ul class = 'list-unstyled text-white font-weight-bold'>

                            <div class = 'side-bar mt-2 pt-4 imagem-verde'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/algoritmos/'
                                        >ALGORITMOS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-carrer'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/carreira/'
                                        >CARREIRA
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-windows'>
                                <li>
                                    <a class = 'text-white'
                                    href = '/tags/dev-no-windows/'
                                    >DEV NO WINDOWS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/devpleno'
                                        >DEVPLENO
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-dicas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/dicas/'
                                        >DICA
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar mt-2 pt-4 imagem-dicas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/dicas/'
                                        >DICAS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-carrer'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/dicas-de-carreira/'
                                        >DICAS DE CARREIRA
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white'
                                        href = '/dicas-de-estudo/'
                                        >DICAS DE ESTUDOS
                                     </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-entrevista'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/entrevistas/'
                                        >ENTREVISTAS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-handsOn'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/hands-on/'
                                        >HANDS-ON
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-JS'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/java-script/'
                                        >JAVASCRIPT
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/maratona-de-programacao/'
                                        >MARATONA DE PROGRAMAÇÃO
                                        </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-NODE'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/node-js/'
                                        >NODEJS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-REACT'>
                                <li>
                                    <a class = 'text-white'
                                        href = '/react/'
                                        >REACTJS
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white'
                                        href = '/socket/'
                                        >SOCKET.IO
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-Cinzas'>
                                <li>
                                    <a class = 'text-white' 
                                        href = '/tecnologia/'
                                        >TECNOLOGIA
                                    </a>
                                </li>
                            </div>

                            <div class = 'side-bar pt-4 mt-2 imagem-web'>
                                <li>
                                    <a class = 'text-white'
                                        href = '/web-basics/'
                                        >WEB-BASICS
                                    </a>
                                </li>
                            </div>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SideBar